@import '../../../../../static/less/variables.less';

.free-sign-up-container {
  .modal-content {
    width: 480px;
  }

  .close-button {
    position: absolute;
    top: 5px;
    right: 15px;
    color: #888;
    font-size: 23px;
    text-decoration: none;
  }

  .modal-header {
    // height: 100px;
    display: flex;
    align-items: center;
  }

  .modal-footer-wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;

    height: 100%;
    padding: 10px;
    overflow-x: hidden;
  }

  .modal-body-wrapper {
    width: 480px;
    padding: 30px;
    padding-top: 40px;
    padding-bottom: 30px;
  }

  .login-link {
    color: #4596e8;
  }
}

.free-sign-up-form {
  min-height: 380px;
  .row {
    margin-top: 20px;

    &:nth-child(1) {
      margin-top: 8px;
    }
  }

  .field-type {
    padding-top: 12px;
  }

  .Select-placeholder {
    // background: url(/static/img/sign_up_question.svg) no-repeat scroll 11px 50%;
    background-size: 20px 20px;
    color: #9a9696;
    font-size: 17px;
    font-weight: normal;
    padding-left: 22px;
  }

  .Select {
    z-index: 2000;
  }

  .Select-value {
    // background: url(/static/img/sign_up_question.svg) no-repeat scroll 7px 50%;
    // background-size: 18px 18px;
    padding-left: 22px !important;
  }

  .Select-control {
    border: 1px solid #dae1ea;
    border-radius: 0px;
    border-top-right-radius: 4px;
    border-bottom-right-radius: 4px;
  }

  .Select-menu-outer {
    z-index: 5001;
  }

  .marketing-section {
    display: flex;
    align-items: center;
    padding: 5px;
    // padding-left: 30px;

    /* Customize the label (the container) */
    .container {
      display: block;
      position: relative;
      padding-left: 25px;
      margin-bottom: 12px;
      width: auto;
      cursor: pointer;
      font-size: 14px;
      -webkit-user-select: none;
      -moz-user-select: none;
      -ms-user-select: none;
      user-select: none;
    }

    .checkbox-label {
      color: #999999;
    }

    /* Hide the browser's default checkbox */
    .container input {
      position: absolute;
      opacity: 0;
      cursor: pointer;
      height: 0;
      width: 0;
    }

    /* Create a custom checkbox */
    .checkmark {
      position: absolute;
      top: 0;
      left: 0;
      height: 18px;
      width: 18px;
      border: 1px solid #dae1ea;
      // background-color: #eee;
    }

    /* On mouse-over, add a grey background color */
    .container:hover input ~ .checkmark {
      // background-color: #ccc;
      opacity: 0.7;
    }

    /* When the checkbox is checked, add a blue background */
    .container input:checked ~ .checkmark {
      background-color: #4596e8;
    }

    /* Create the checkmark/indicator (hidden when not checked) */
    .checkmark:after {
      content: '';
      position: absolute;
      display: none;
    }

    /* Show the checkmark when checked */
    .container input:checked ~ .checkmark:after {
      display: block;
    }

    /* Style the checkmark/indicator */
    .container .checkmark:after {
      left: 5.5px;
      top: 2px;
      width: 5px;
      height: 10px;
      border: solid white;
      border-width: 0 3px 3px 0;
      -webkit-transform: rotate(45deg);
      -ms-transform: rotate(45deg);
      transform: rotate(45deg);
    }
  }

  .recaptcha-section {
    width: 402px;
    height: 78px;
    .has-error {
      position: absolute;
    }
  }

  .g-recaptcha > div {
    width: inherit !important;
    position: relative;
    display: block;
    padding: 0;
    overflow: hidden;
    //min-height: 78px;
    max-width: 214px;
    border-right: 1px solid #d3d3d3;
    border-radius: 4px;
    box-shadow: 2px 0 4px -1px rgba(0, 0, 0, 0.08);
    -webkit-box-shadow: 2px 0 4px -1px rgba(0, 0, 0, 0.08);
    -moz-box-shadow: 2px 0 4px -1px rgba(0, 0, 0, 0.08);
  }

  .g-recaptcha iframe {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 100%;
    border: 0;
  }

  .g-recaptcha > div {
    position: relative;
  }

  .email {
    background-image: url(/static/img/sign_up_email.svg);
    background-repeat: no-repeat;
    background-size: 20px 20px;

    position: absolute;
    left: 10px;
    top: 15px;
    width: 20px;
    height: 20px;
  }

  .phone {
    background-image: url(/static/img/sign_up_phone.svg);
    background-repeat: no-repeat;
    background-size: 20px 20px;

    position: absolute;
    left: 10px;
    top: 15px;
    width: 20px;
    height: 20px;
  }

  .career {
    background-image: url(/static/img/icons/icon_career_pro.png);
    background-repeat: no-repeat;
    background-size: 20px 20px;

    position: absolute;
    left: 10px;
    top: 15px;
    width: 20px;
    height: 20px;
  }

  .question {
    background: url(/static/img/sign_up_question.svg) no-repeat scroll 7px 50%;
  }

  .name {
    background-image: url(/static/img/sign_up_name.svg);
    background-repeat: no-repeat;
    background-size: 20px 20px;

    position: absolute;
    left: 10px;
    top: 15px;
    width: 20px;
    height: 20px;
  }

  .password {
    background-image: url(/static/img/sign_up_password.svg);
    background-repeat: no-repeat;
    background-size: 20px 20px;

    position: absolute;
    left: 10px;
    top: 15px;
    width: 20px;
    height: 20px;
  }

  .email-warn {
    position: absolute;
    left: 80px;
    top: -30px;
    background-color: rgba(0, 0, 0, 0.7);
    color: white;
    padding: 8px;
    border-radius: 4px;
  }

  .arrow {
    position: absolute;
    left: 190px;
    top: 4px;
    width: 0;
    height: 0;
    border-style: solid;
    border-width: 10px 10px 0 10px;
    border-color: rgba(0, 0, 0, 0.7) transparent transparent transparent;
  }

  .special-input {
    width: 100%;
    height: 46px;
    padding: 10px 24px;
    font-size: 18px;
    line-height: 1.3333333;
    border-radius: 6px;
    padding-left: 40px;
    background-size: 18px 18px;
    background-color: white;
    border: 0.5px solid #dae1ea;
    border-radius: 4px;
    color: black;

    transition: border-color ease-in-out 0.15s, box-shadow ease-in-out 0.15s;
    box-shadow: inset 0 0.5px 0.5px rgba(0, 0, 0, 0.075);

    &:hover {
      border-color: #4596e8;
    }

    &:focus {
      border-color: #4596e8;
      outline: 0;
      box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 8px rgba(69, 150, 232, 0.6);
    }

    &::placeholder {
      /* Chrome, Firefox, Opera, Safari 10.1+ */
      color: #999999;
      opacity: 1; /* Firefox */
      font-size: 15px;
    }

    &:-ms-input-placeholder {
      /* Internet Explorer 10-11 */
      color: #999999;
    }

    &::-ms-input-placeholder {
      /* Microsoft Edge */
      color: #999999;
    }
  }

  .button-submit {
    width: 100%;
  }

  .error {
    color: red;
  }
}

.signup-desktop {
  height: 100vh;
  background-image: url(../../../../../static/img/blur_new_blue.jpg);
  background-size: cover;
  width: 1182px;
  // margin: auto;
  /* height: 100%; */
}

.signup-mobile {
  display: none;
}

@media screen and (max-width: @screen-sm-max) {
  .signup-mobile {
    display: block;
  }

  .signup-desktop {
    display: none;
    visibility: none;
  }
}



// WEBPACK FOOTER //
// webpack:///sef/pro/assets/routes/SignUpPage/components/SignUpStyle.less